import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`
  body {
    background: #363537;
    color: ${({ theme }) => theme.text.onSurface.strong};
    font-family:  "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
    font-size: 0.75rem;
    transition: all 0.50s linear; 
    min-height:100vh;
  }
  `;
